import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";


class YilListeAPI extends BaseAPI {

  constructor() {
    const baseUrl = environment.API_URL + "YilListe";
    super(baseUrl);
  }
  getYilListe() {
    return this.get();
  }

}
export default new YilListeAPI();
